import { call, put, takeLatest } from 'redux-saga/effects';
import { ServerDetails } from 'types';
import { serverDetailsSuccess, serverDetailsFailure } from 'actions/serverActions';
import { handleErrorSaga } from 'sagas/app/handleError';
import { getServerDetails } from 'api';
import { parseWin32SystemTime } from './parseWin32SystemTime';

export function* serverDetailsRequestWatcher() {
    yield takeLatest('SERVERDETAILS_REQUEST', getServerDetailsSaga);
}

export function* getServerDetailsSaga() {
    let apiServerDetails: any; // tslint:disable-line
    let serverDetails: ServerDetails | null = null;

    try {
        apiServerDetails = yield call(getServerDetails);
        const { timezone } = apiServerDetails;

        serverDetails = {
            ...apiServerDetails,
            timezone: {
                ...timezone,
                daylightStart: parseWin32SystemTime(timezone.daylightStart),
                standardStart: parseWin32SystemTime(timezone.standardStart),
            },
        };
    }
    catch (err) {
        yield call(handleErrorSaga, err, serverDetailsFailure);
        return;
    }
    yield put(serverDetailsSuccess(serverDetails!));
}



// WEBPACK FOOTER //
// ./src/sagas/server/serverDetailsRequestSaga.ts